import { TItemType } from '@types';

/**
 * An Item rate card's title: its Item type's name. One with no Item type to name reads "Deleted
 * item type", but only once the live Item types have loaded, rather than say that of every Item type
 * in the meantime.
 */
export const getItemRateCardTitle = (itemType: Pick<TItemType, 'name'> | undefined, itemTypesLoaded: boolean) => {
	if (itemType) return itemType.name;
	return itemTypesLoaded ? 'Deleted item type' : '';
}
